import React from 'react';
import Info from '../Info';
import { AppointmentInfo, SCHEDULES_TYPES_MAPPED } from '../..';

const stethoscopeIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/estetoscopio.svg';
const PatientIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/patient.svg';
import { ReactComponent as CheckupServiceIcon } from '../../../../assets/checkup-service.svg';
import { SchedulesTypes } from '../../../../utils/constants';
import { ICON_BY_SCHEDULE_TYPE } from '../AppointmentSGH';

export const HeadTypeByName: React.FC<{ name: string; appointment: AppointmentInfo }> = ({ name, appointment }) => {
  const handleCheckupName = (name: string) => {
    const splittedName = name.split(' - ');
    if (splittedName.length > 1) return splittedName[1];
    return name;
  };

  if (appointment?.scheduleType !== SchedulesTypes.CONSULTATION)
    return (
      <Info
        icon={<img src={ICON_BY_SCHEDULE_TYPE[appointment.scheduleType] || ICON_BY_SCHEDULE_TYPE.DEFAULT} />}
        title={appointment?.scheduleType ? SCHEDULES_TYPES_MAPPED[appointment?.scheduleType] : ''}
        subtitle={appointment?.product.name || ''}
      />
    );

  if (name === 'Consulta equipe de cuidado')
    return (
      <Info
        icon={
          <img
            className="image"
            src={`https://aps-digital.s3.amazonaws.com/profissionais/${appointment?.resource?.crm}.jpg`}
            alt="Specialist"
            onError={({ currentTarget }) => {
              currentTarget.onerror = null; // prevents looping
              currentTarget.src = PatientIcon;
            }}
          />
        }
        title={name}
        subtitle={appointment?.resource?.name || ''}
      />
    );

  if (name === 'Consulta Check-up' || name === 'Consulta')
    return (
      <Info icon={<CheckupServiceIcon />} title={name} subtitle={handleCheckupName(appointment?.product?.name || '')} />
    );

  return (
    <Info
      icon={<img src={stethoscopeIcon} />}
      title={name}
      subtitle={handleCheckupName(appointment?.product?.name || '')}
    />
  );
};
